import { render, staticRenderFns } from "./proceso_recepcionar.vue?vue&type=template&id=7833b3ba&scoped=true&"
import script from "./proceso_recepcionar.vue?vue&type=script&lang=ts&"
export * from "./proceso_recepcionar.vue?vue&type=script&lang=ts&"
import style0 from "./proceso_recepcionar.vue?vue&type=style&index=0&id=7833b3ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7833b3ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
